/* notStarted: When the user has selected an account but didn't press the NEXT button */
export enum isValidationLoadingType {
  loading = 'loading',
  passed = 'passed',
  failed = 'failed',
  disable = 'disable',
  hide = 'hide',
  notStarted = 'notStarted',
  list = 'list',
}
